var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mt-4"},[_c('v-col',{staticClass:"pb-0",attrs:{"cols":"12"}},[_c('v-sheet',{staticClass:"py-2 px-4",attrs:{"color":"blue lighten-5","rounded":""}},[_c('span',{staticClass:"text-subtitle-1 font-weight-bold blue--text"},[_vm._v(_vm._s(_vm.titulo))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }